
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"aria-hidden":"true","viewBox":"0 0 45 45","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M34.84 36.91A17.446 17.446 0 0040 24.5v-3C40 11.835 32.165 4 22.5 4S5 11.835 5 21.5v3c0 4.85 1.973 9.24 5.16 12.41C11.123 30.73 16.274 26 22.5 26c6.227 0 11.378 4.73 12.34 10.91zm-1.85 1.599C32.744 32.653 28.133 28 22.5 28s-10.244 4.653-10.49 10.509A17.422 17.422 0 0022.5 42c3.935 0 7.567-1.299 10.49-3.491zM22.5 2C33.27 2 42 10.73 42 21.5v3C42 35.27 33.27 44 22.5 44S3 35.27 3 24.5v-3C3 10.73 11.73 2 22.5 2zm.5 21a7 7 0 110-14 7 7 0 010 14zm0-2a5 5 0 100-10 5 5 0 000 10z"}})])
          )
        }
      }
    